/**
 * PositionSection — the POSITION block of the publish-shift drawer: one radio per crew role.
 *
 * Extracted from PublishShiftDrawer so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
import type { CrewPosition } from '../../../api/workshops';
import { crewPositionLabel } from '../../../lib/crewPositions';
import { CREW_ROLES } from '../workshops/detail/crewModel';

const EM_DASH = '—';

export function PositionSection({
  position,
  onSelect,
}: {
  position: CrewPosition;
  onSelect: (p: CrewPosition) => void;
}) {
  return (
    <section style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--nb-muted)' }}>POSITION</div>
      {CREW_ROLES.map((role) => (
        <label
          key={role}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 10,
            padding: '8px 10px',
            borderRadius: 8,
            border: `1px solid ${position === role ? 'var(--nb-primary)' : 'var(--nb-border)'}`,
            background: position === role ? 'var(--nb-primary-soft)' : 'var(--nb-surface)',
            cursor: 'pointer',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <input
              type="radio"
              name="publish-shift-position"
              checked={position === role}
              onChange={() => onSelect(role)}
              style={{ accentColor: 'var(--nb-primary)' }}
            />
            <span style={{ fontSize: 12, fontWeight: 600 }}>{crewPositionLabel(role)}</span>
          </span>
          {/* TODO(BON-245): per-position shift pay. */}
          <span className="nb-mono" style={{ fontSize: 11, color: 'var(--nb-subtle)' }}>
            {EM_DASH}
          </span>
        </label>
      ))}
    </section>
  );
}
